<div [formGroup]="form">
  <div
    class="repeatable-card-field"
    *ngFor="let project of projects; let i = index">
    <mat-form-field>
      <input
        matInput
        placeholder="Progetto"
        [formControlName]="i">
    </mat-form-field>

    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      mat-raised-button
      type="button"
      (click)="removeHandler(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    (click)="addHandler()">
    {{ 'Aggiungi progetto' | translate }}
  </button>
</div>
